<template>
    <v-container tag="section">
        <v-row>
            <v-col class="py-8 pb-3 pb-sm-4">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row class="flex-column flex-sm-row flex-wrap">
            <v-col v-for="item in updates" :key="item.id" class="py-sm-0 pt-sm-4 d-flex" sm="6" cols="12">
                <v-card class="v-card__borders-govt--left py-8" target="_blank" :href="item.href" tile flat outlined >
                    <v-card-title class="px-4 px-sm-7 pt-0">
                        <h4>
                            {{ item.title }}
                            <v-card-actions class="ml-auto">
                                <v-btn icon :title="`Opens in new tab. Show more information on ${item.title}`">
                                    <v-icon right color=secondary>mdi-open-in-new</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </h4>
                    </v-card-title>
                    <v-card-text class="px-4 px-sm-7 pb">
                        <p>{{ item.body }}</p>
                    </v-card-text>
                    <v-card-subtitle class="px-4 px-sm-7 py-0">{{ item.date }}</v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        data: () => ({
            updates: []
        }),
        mounted() {
            this.$axios.get(this.$store.state.client_vars.GOVT_UPDATES)
                .then(response => {
                    this.updates = response.data
                })
                .catch(error => console.log('Failed to update from MOH', error))
        }
    }
</script>

<style scoped lang="scss">
    .v-card__title {

        h4 {
            position: relative;
            width: 100%;
            display: flex;
        }
        
        * {
            margin-bottom: 0;
            padding: 0;
        }
    }

    .v-card__text {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.63;
        color: #121212!important;

        *:last-child {
            margin-bottom: 0;
        }
    }

    .v-card__subtitle {
        font-size: 14px;
        font-weight: 500;
        line-height: 30px;
    }
</style>